export default {
  productUnavailable:
    "Kody tymczasowo wyprzedane. Prosimy o cierpliwość, niedługo ponownie będą dostępne.",
};
